import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { LoggedInContext } from "../../providers/LoggedInContext";
import { BrandCountryContext } from "../../providers/BrandCountryProvider";

const PrivateRoutes2 = () => {
    const {loggedIn} = useContext(LoggedInContext);
    const {brand} = useContext(BrandCountryContext);

    if(loggedIn){
        return (
            <Outlet /> 
        )
    } else {
        return (
            <Navigate to="/hiq/login" />
        ) 
    }
}

export default PrivateRoutes2;